<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('ajoutEditContrat.bailleur.title')}}</p>
    </header>
    <div class="card-content">
      <b-table :data="contrat.intervenants" :bordered="true" :striped="true">
        <b-table-column field="bailleur" class="verticalAlignementBTable" v-slot="props"
                        :label="$i18n.t('ajoutEditContrat.bailleur.bailleur')">
          <div v-if="!props.row.tiersId">
            <b-autocomplete v-model="nomBailleur"
                            :open-on-focus="false"
                            :data="bailleurs"
                            field="nomWithAdresseAndCompteComptable"
                            :placeholder="$i18n.t('ajoutEditContrat.bailleur.ajouterBailleur')"
                            @input="getBailleur"
                            :loading="isFetching"
                            @select="ajoutIntervenant">
              <template slot="header">
                <a @click="checkPermissions(constantes.BAILLEUR.maj)
                  ? isComponentAjoutBailleur = true : showPopUp()">
                  <a class="lien"
                     :class="{ 'text-access-no-permission' :
                     !checkPermissions(constantes.BAILLEUR.maj)}">
                    <span>+ {{$t('ajoutEditContrat.bailleur.addNewBailleur')}}</span>
                  </a>
                </a>
              </template>
              <template slot="empty">
                <div v-if="!isFetching">
                  {{$t('ajoutEditContrat.materiel.actions.noResult')}}
                </div>
                <div v-else>
                  {{$t('ajoutEditContrat.materiel.actions.searchEnCours')}}
                </div>
              </template>
            </b-autocomplete>
          </div>
          <div v-else>
            <router-link-blank :to="{ name: 'c.baux.bailleur',
              params: { id: props.row.tiersId } }"
                               :message="props.row.tiers.nomCommercial">
            </router-link-blank>
          </div>
        </b-table-column>
        <b-table-column field="adresse" class="verticalAlignementBTable" v-slot="props"
                        :label="$i18n.t('ajoutEditContrat.bailleur.adresse')">
          <div v-if="props.row.tiersId">
            {{ getLibelleAdresse(props.row.tiers.adressePostale) }}
          </div>
        </b-table-column>
        <b-table-column field="repartition" v-slot="props"
                        :label="$i18n.t('ajoutEditContrat.bailleur.quotePart')">
          <div v-if="props.row.tiersId" class="is-paddingless">
            <b-field>
              <inputCurrency v-model="props.row.repartition" class="full-width mgr-5px">
              </inputCurrency>
              <p class="height-fit-content mg-auto mgr-0 mgl-0">
                {{ $t('ajoutEditContrat.bailleur.pourcentage') }}</p>
            </b-field>
          </div>
        </b-table-column>
        <b-table-column field="modePaiement" class="verticalAlignementBTable"
                        v-slot="props"
                        :label="$i18n.t('ajoutEditContrat.bailleur.modePaiement')">
          <div v-if="props.row.tiersId">
            <b-select v-model="props.row.modeReglementId" expanded>
              <option></option>
              <option v-for="modeReglement in modesReglement"
                      :key="modeReglement.id"
                      :value="modeReglement.id">
                {{modeReglement.libelle}}
              </option>
            </b-select>
          </div>
        </b-table-column>
        <b-table-column field="surFacture" class="verticalAlignementBTable" v-slot="props"
                        :label="$i18n.t('ajoutEditContrat.bailleur.surFacture')">
          <div v-if="props.row.tiersId" class="has-text-centered">
            <qd-checkbox v-model="props.row.surFacture">
            </qd-checkbox>
          </div>
        </b-table-column>
        <b-table-column field="delete" centered class="verticalAlignementBTable" v-slot="props">
          <a v-if="props.row.tiersId"
             @click="deleteIntervenant(props.index)">
            <b-icon icon="delete-forever" type="is-danger">
            </b-icon>
          </a>
        </b-table-column>
      </b-table>
      <b-modal v-model="isComponentAjoutBailleur"
               has-modal-card
               class="modal"
               @close="nomBailleur=''">
        <quick-add-new-bailleur @newBailleur="ajoutIntervenant"
            :nomBailleur="nomBailleur"></quick-add-new-bailleur>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { getAll } from '@/api/tiers';
import {
  TIERS_SOUS_TYPE_BAILLEUR_PRO,
  TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
} from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import inputCurrency from '@/components/general/inputCurrency';
import messageErreur from '@/services/general/messageErreur';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import genererIntervenantContrat from '@/services/baux/contrat/genererIntervenantContrat';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { BAILLEUR } from '@/configuration/baux/permissionsBauxConf';
import quickAddNewBailleur from '@/components/baux/contrat/componentEdition/p_quickAddNewBailleur';

const societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'BauxContratEditBailleur',
  data() {
    return {
      bailleurs: [],
      isFetching: false,
      isComponentAjoutBailleur: false,
      constantes: {
        BAILLEUR,
      },
      nomBailleur: null,
    };
  },
  components: {
    inputCurrency,
    routerLinkBlank,
    quickAddNewBailleur,
  },
  props: {
    contrat: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getLibelleAdresse(adresseObject) {
      if (adresseObject === null) { return ''; }
      return adressFullStringGetter(adresseObject, false);
    },
    deleteIntervenant(index) {
      this.contrat.intervenants.splice(index, 1);
    },
    ajoutIntervenant(tiers) {
      if (!tiers) return;
      const intervenant = genererIntervenantContrat();
      intervenant.tiers = tiers;
      intervenant.modeReglement = tiers.modeReglement;
      intervenant.modeReglementId = tiers.modeReglementId;
      intervenant.repartition = this.contrat.intervenants.length - 1 > 0 ? 0 : 100;
      intervenant.tiersId = tiers.id;
      if (this.contrat.tauxTva !== 0) intervenant.surFacture = true;
      this.contrat.intervenants.unshift(intervenant);
      this.nomBailleur = '';
    },
    getBailleur: debounce(async function bailleurData(nomBailleur) {
      try {
        this.isFetching = true;
        const bailleursList = (await getAll({
          query: {
            type: TIERS_TYPE_FOURNISSEUR,
            archive: false,
            auto: nomBailleur,
            sousType: [
              TIERS_SOUS_TYPE_BAILLEUR_PRO,
              TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
              TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
              TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
            ],
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        bailleursList.map((bailleur) => {
          bailleur.nomWithAdresseAndCompteComptable = [
            bailleur.code, bailleur.nomCommercial,
            adressFullStringGetter(bailleur.adressePostale, false),
            bailleur.compteComptable,
          ].filter((item) => !!item).join(' - ');
          return bailleur;
        });
        this.bailleurs = bailleursList.filter((bailleur) => {
          return !this.contrat.intervenants.find((intervenant) => {
            return intervenant.tiersId === bailleur.id;
          });
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    modesReglement() {
      const modesReglement = this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
      return modesReglement.filter((modeReglement) => {
        return modeReglement.actionAchat !== AUCUN;
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.modeReglement,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
